import actions from '../../actionTypes';

export default (email,host) => {
  return {
    type: actions.CHECK_SSO,
    email: email,
    host: host
  };
};



// WEBPACK FOOTER //
// ./src/reducers/auth/actions/checkSSO.js